// extracted by mini-css-extract-plugin
export default {"main":"Checkbox_main__PQ7XV","textlabel":"Checkbox_textlabel__lbPF3"};